import PhoneIcon from './Brief/PhoneIcon';

/**
 * Phones only, briefs and scripts (mock-up §06, screen 1): the header's Shoot
 * view button is easy to miss in a wrapping row on a small screen, so the
 * offer is repeated once as a card between the review card and the document.
 * Tapping it opens the shoot view in place, the way phones expect. The blurb
 * says what the page holds, which differs between a brief and a script.
 */

export default function ShootViewCard({ onOpen, blurb }: { onOpen: () => void; blurb: string }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="
        w-full flex items-center justify-between gap-3
        px-4 py-3.5 rounded-md border border-line bg-card text-left
        hover:border-accent transition-colors
      "
    >
      <span className="flex items-center gap-3 min-w-0">
        <span className="text-accent flex-none [&_svg]:w-[18px] [&_svg]:h-[18px]">
          <PhoneIcon />
        </span>
        <span className="min-w-0">
          <span className="block text-[15px] font-medium text-fg">Open the shoot view</span>
          <span className="block text-[12px] text-muted">
            {blurb}
          </span>
        </span>
      </span>
      <span aria-hidden className="text-faint flex-none">
        ›
      </span>
    </button>
  );
}
